module.exports = __webpack_public_path__ + "files/SPIADI2026 - BACT ADI+ - Guide Technique (Version 2).d6bb6a2214877ecca15dabf50411a6de.pdf";